import { STORAGE_FLOATING_MENU } from '@/utils/constants'
import SafeLocalStorage from '../safe-local-storage'
import Wallet from '@/utils/wallet'

export default class WalletSettings {
	public static init() {
		SafeLocalStorage.setItem(STORAGE_FLOATING_MENU, 'true', true)
	}

	public static floatingMenu(): boolean {
		if (!Wallet.isSet()) {
			return false
		}

		let value = localStorage.getItem(STORAGE_FLOATING_MENU)

		if (!value) {
			SafeLocalStorage.setItem(STORAGE_FLOATING_MENU, 'false')
			return false
		}

		return value === 'true'
	}

	public static toggleFloatingMenu() {
		try {
			if (!Wallet.isSet()) {
				return
			}

			if (this.floatingMenu()) {
				SafeLocalStorage.setItem(STORAGE_FLOATING_MENU, 'false', true)
			} else {
				SafeLocalStorage.setItem(STORAGE_FLOATING_MENU, 'true', true)
			}
		} catch (e) {
			console.log(e)
		}
	}
}
